import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=057ed015&scoped=true&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentPage.vue?vue&type=style&index=0&id=057ed015&scoped=true&lang=css&"
import style1 from "./StudentPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ed015",
  null
  
)

export default component.exports